module.exports = __webpack_public_path__ + "static/media/iconActivity.297a1377.svg";